import { bootstrapApplication } from '@angular/platform-browser';

import { appConfig } from './app/app.config';
import { App } from './app/app';

declare const Office: { onReady?: (cb: () => void) => void } | undefined;

function start(): void {
  bootstrapApplication(App, appConfig).catch((err) => console.error(err));
}

// Inside an Outlook host, wait for Office.js; in a plain browser (dev
// harness) the CDN script may be absent or inert — boot immediately.
if (typeof Office !== 'undefined' && Office?.onReady) {
  let booted = false;
  const bootOnce = () => {
    if (!booted) {
      booted = true;
      start();
    }
  };
  Office.onReady(bootOnce);
  // Office.onReady never fires outside a host page — don't hang the harness.
  setTimeout(bootOnce, 2000);
} else {
  start();
}
